// A tab opened before a deploy still holds the old HTML, so when it finally
// lazy-loads a chunk it asks for a filename from a build that no longer
// matches. Content hashing stopped new deploys overwriting each other, but it
// cannot help sessions that predate it - we have seen tabs sit open for six
// days before failing. Those shoppers land on a dead checkout with no way
// forward, so reload once and let them continue on the current build.
//
// Safe to do at this point specifically because the failure *is* code that
// never loaded: whatever the shopper was trying to do never ran, so there is
// no in-flight submission to interrupt. Checkout progress itself lives on
// BigCommerce (addresses, consignments, coupons are persisted as they go), so
// a reload restores the session rather than discarding it - only keystrokes in
// an unsaved field are lost, against a page that is otherwise unusable.

var RELOAD_FLAG = "vino-checkout-chunk-reload";

// webpack's own errors, then the two shapes a module-id mismatch takes once
// minified - V8 and JavaScriptCore word it differently. Matched tightly: a
// looser rule would reload the page on unrelated bugs.
var CHUNK_ERROR_PATTERNS = [/Loading chunk [\w-]+ failed/i, /Loading CSS chunk [\w-]+ failed/i, /Cannot read propert(?:y|ies) of undefined \(reading 'call'\)/, /undefined is not an object \(evaluating '[^']*\.call'\)/];
var isChunkLoadFailure = function isChunkLoadFailure(error) {
  var _ref = error !== null && error !== void 0 ? error : {},
    name = _ref.name,
    message = _ref.message;
  if (name === "ChunkLoadError") return true;
  return !!message && CHUNK_ERROR_PATTERNS.some(function (pattern) {
    return pattern.test(message);
  });
};

// The flag has to survive the reload or we would reload forever. If it cannot
// be written back and read again - Safari private mode, storage disabled, quota
// - we leave the page broken rather than risk an endless refresh loop.
var claimTheSingleReload = function claimTheSingleReload() {
  try {
    if (sessionStorage.getItem(RELOAD_FLAG)) return false;
    sessionStorage.setItem(RELOAD_FLAG, "1");
    return sessionStorage.getItem(RELOAD_FLAG) === "1";
  } catch (_unused) {
    return false;
  }
};
var reloadOnce = function reloadOnce(error) {
  if (!isChunkLoadFailure(error)) return;
  if (!claimTheSingleReload()) return;
  // Honeybadger sends its notice asynchronously; reloading in the same tick
  // would drop it and hide how long this tail actually runs.
  setTimeout(function () {
    return window.location.reload();
  }, 1000);
};

// Guarded because this runs at the entry point before React mounts - a throw
// here would take the whole checkout down for the sake of a recovery path.
export var registerChunkReload = function registerChunkReload() {
  try {
    window.addEventListener("error", function (event) {
      return reloadOnce(event.error);
    });
    window.addEventListener("unhandledrejection", function (event) {
      return reloadOnce(event.reason);
    });
  } catch (error) {}
};